import { createContext, useContext } from "react";
import type { BoardLayoutController } from "../hooks/useBoardLayout.js";

export const LayoutContext = createContext<BoardLayoutController | null>(null);

/** The composition's board layout controller. Throws outside the provider. */
export function useLayoutContext(): BoardLayoutController {
  const v = useContext(LayoutContext);
  if (!v) {
    throw new Error("useLayoutContext must be used within a <LayoutProvider>");
  }
  return v;
}

/**
 * Like {@link useLayoutContext} but returns null instead of throwing when no
 * provider is mounted — for the board, which falls back to a local layout in
 * provider-less compositions (marketing demo, Studio preview).
 */
export function useLayoutContextOptional(): BoardLayoutController | null {
  return useContext(LayoutContext);
}
